const types = {
    SET_HISTORY_LIST: '[JACKPOT HISTORY] SET HISTORY LIST',
}

export {
    types
}